import React from "react"
import { useSettings } from "../editor"

export default function OutlookSpacingTable({
  spaceSetting,
  padding,
  children
}) {
  const settings = useSettings()
  const space = settings.find(s => s.name === spaceSetting).value
  const width = space === "thin" ? "600" : "100%"
  const paddingStyle = padding ? `style="padding: ${padding}"` : ""
  const msoWrap = html => "</div><!--[if mso]>" + html + "<![endif]--><div>"
  const msoStart = `
    <table height="100%" width="${width}" cellpadding="0" cellspacing="0" border="0">
      <tr>
        <td ${paddingStyle}>`
  const msoEnd = "</td></tr></table>"

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: msoWrap(msoStart) }} />
      {children}
      <div dangerouslySetInnerHTML={{ __html: msoWrap(msoEnd) }} />
    </>
  )
}
